export const INVENTORY_WAREHOUSE = 'INVENTORY_WAREHOUSE';

type State = {
  inventoryWarehouse: string | undefined;
};

type Action = {
  type: string;
  inventoryWarehouse?: string;
};

export const actionMap = {
  [INVENTORY_WAREHOUSE]: (state: State, { inventoryWarehouse }: Action): State => {
    return {
      ...state,
      inventoryWarehouse,
    };
  },
};

export const initialState: State = {
  inventoryWarehouse: undefined,
};
